






















































import {
  Vue,
  servicesURL,
  payfortAccessCode,
  getCookie,
  cookies,
  payfortMerchantIdentifier,
} from "../../constants/constants";
import { genericErrorsEnum } from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang";

import EventBus from "./../../eventBus";
export default Vue.component("choose-payment", {
  data() {
    return {
      servicesURL,
      staticContent,
      genericErrorsEnum,
      month: "",
      year: "",
      expiryDate: "",
      cvv: "",
      number: "",
      name: "",
      showSuccess: false,
      openCardForm: false,
    };
  },
  props: {
    ispromo: false,
  },
  computed: {
    requestString() {
      return `?access_code=${payfortAccessCode}&language=${getCookie(
        cookies.lang
      ).toLowerCase()}&merchant_identifier=${payfortMerchantIdentifier}&merchant_reference=${
        this.cardRequest.merchantReference
      }&service_command=TOKENIZATION&signature=${this.cardRequest.signature}`;
    },
    bindConditionalClasses() {
      return this.$root.bindConditionalClasses;
    },
    basket() {
      return this.$store.state.basket;
    },
    userEmail() {
      return this.$store.state.profile.data.email;
    },
    profile() {
      return this.$store.state.profile;
    },
    loading() {
      return this.$store.state.cardsLoading;
    },
    cardRequest() {
      return this.$store.state.cardRequest;
    },
    creditCards() {
      return this.$store.state.creditCards;
    },
    promoForm() {
      return this.$store.state.promoForm;
    },
  },
  mounted() {
    console.log("loading", this.loading);
    EventBus.$on("chooseCard", (uuid) => this.closeAndChooseCard(uuid));
    window.addEventListener(
      "message",
      (event) => {
        if (event.data && typeof event.data === "string") {
          let otpResponse = JSON.parse(event.data);
          this.validatePayfortResponse(otpResponse)
            .then(() => {
              if (otpResponse.fort_id) {
                this.verifyCard(otpResponse);
              } else if (otpResponse.service_command == "TOKENIZATION") {
                this.authorizeCard(otpResponse);
              }
            })
            .catch(() => {
              this.$store.commit("addCardError", "1");
              this.$store.commit("addCardLoading", false);
              this.$store.dispatch("PREP_ADD_CREDIT_CARD");
            });
        }
      },
      false
    );
  },
  methods: {
    validatePayfortResponse(responseObj) {
      return new Promise((resolve, reject) => {
        let { signature, ...responseWithoutSign } = responseObj;
        let signatureString = Object.entries(responseWithoutSign)
          .sort((a, b) => {
            if (a[0] > b[0]) return 1;
            else if (a[0] < b[0]) return -1;
            else return 0;
          })
          .map((item) => item[0] + "=" + item[1])
          .join("");
        this.$store
          .dispatch("GENERATE_PAYFORT_SIGNATURE", signatureString)
          .then((res) => {
            signature == res ? resolve() : reject();
          })
          .catch(() => {
            reject();
          });
      });
    },
    updateExpiry() {
      this.expiryDate =
        this.month.length == 1
          ? this.year + "0" + this.month
          : this.year + "" + this.month;
    },
    authorizeCard(responseObj) {
      if (responseObj) {
        this.$store.commit("updateCardRequest", responseObj);
        if (responseObj.response_message.toLowerCase() == "success") {
          this.$store.dispatch("AUTHORIZE_CREDIT_CARD");
        } else {
          this.$store.commit("addCardError", responseObj.response_code);
          this.$store.commit("addCardLoading", false);
          this.$store.dispatch("PREP_ADD_CREDIT_CARD");
        }
      }
    },
    verifyCard(responseObj) {
      if (responseObj) {
        this.$store.commit("updateCardRequest", responseObj);
        if (responseObj.response_message.toLowerCase() == "success") {
          this.$store.dispatch("VERIFY_CREDIT_CARD");
        } else {
          this.$store.commit("addCardError", responseObj.response_code);
          this.$store.commit("addCardLoading", false);
          this.$store.dispatch("PREP_ADD_CREDIT_CARD");
        }
      }
    },
    validateBeforeSubmit(e) {
      this.$store.commit("addCardError", null);
      this.$validator.validate().then((valid) => {
        if (valid) {
          this.$store.commit("addCardLoading", true);
        } else {
          e.preventDefault();
        }
      });
    },
    closeCardForm() {
      this.month = "";
      this.year = "";
      this.cvv = "";
      this.number = "";
      this.name = "";
      this.openCardForm = false;
      this.showSuccess = false;
      this.$store.commit("emptyCardRequest");
     this.creditCards.length <= 0 && this.closeModal();
    },
    openAddCardForm() {
      this.openCardForm = true;
      this.$store.dispatch("PREP_ADD_CREDIT_CARD");
    },
    closeAndChooseCard(uuid) {
      this.showSuccess = true;
      let chooseCard = this;
      setTimeout(function () {
        chooseCard.closeCardForm();
        chooseCard.updatePaymentCard(uuid);
      }, 1500);
    },

    updatePaymentCard(carduuid) {
      if (!this.ispromo) {
        this.$store.commit("updateBasketPaymentCard", carduuid);
        if (navigator.onLine) {
          this.$store
            .dispatch("UPDATE_BASKET_PAYMENT_METHOD", {
              method: this.basket.payment.paymentTypeEnum.CREDIT_CARD,
              carduuid: carduuid,
            })
            .catch(() => {
              this.$root.handleGenericErrors(genericErrorsEnum.generic);
            });
        } else {
          this.$root.handleGenericErrors(genericErrorsEnum.internet);
        }
      } else {
        this.$store.commit("updateGiftingPaymentCard", carduuid);
      }
    },

    closeModal() {
      //this.creditCards.length <= 0 &&
       this.$root.modalToggler("payment-type-modal", "hide");
    },
  },
});
